import $ from 'jquery';

$(document).ready(function () {
  const $video = $('.e-video');

  //
  $video.each(function () {
    const $thisVideo = $(this);
    const video = $thisVideo.find('video')[0];

    //
    $thisVideo.find('.play').on('click', function (event) {
      event.preventDefault();

      video.play();
      $thisVideo.addClass('playing');
    });

    //
    video.addEventListener('pause', function () {
      $thisVideo.removeClass('playing');
    });

  });
});



// WEBPACK FOOTER //
// ./app/ui/elements/video/index.js